import React from 'react'
import ViewDemo from './components/ViewDemo'
import ViewVideo from './components/viewVideo'
import CAProvinces from './data/geo/states-provinces/CA_for_leads.json'
import USStates from './data/geo/states-provinces/US_for_leads.json'
const NON_US_OR_CANADA_STATE = 'XX';

export const addPropsToAllChildren = (children, props) => {
    return React.Children.map(children, child => {
        return React.cloneElement(child, {
            ...props,
        })
    })
}

export const buildCTALink = (ctaButton, productHint = null, largeButton = false) => {
    let ctaButtonEl

    if (typeof ctaButton !== 'undefined' && ctaButton !== null) {
        const type =
            typeof ctaButton.type !== 'undefined' && ctaButton.type !== null
                ? ctaButton.type
                : typeof ctaButton.href !== 'undefined'
                ? 'link'
                : null

        switch (type) {
            case 'video':
                ctaButtonEl = (
                    <ViewVideo url={ctaButton.url}>
                        <button
                            className={`button button-primary ${productHint &&
                                productHint.toLowerCase()} __cta_tag`}
                        >
                            {ctaButton.text}
                        </button>
                    </ViewVideo>
                )
                break
            case 'demo':
                ctaButtonEl = (
                    <ViewDemo checked={productHint}>
                        <button
                            className={`button button-primary ${productHint &&
                                productHint.toLowerCase()} __cta_tag`}
                        >
                            {ctaButton.text}
                        </button>
                    </ViewDemo>
                )
                break
            case 'link':
                ctaButtonEl = (
                    <a
                        href={ctaButton.href}
                        className={`button button-primary ${largeButton ? 'button-large' : ''} ${productHint &&
                            productHint.toLowerCase()} __cta_tag`}
                    >
                        {ctaButton.text}
                    </a>
                )
                break
            default:
                ctaButtonEl = null
                break
        }
    }

    return ctaButtonEl
}

export const getClosest = function(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (
                        this.document || this.ownerDocument
                    ).querySelectorAll(s),
                    i = matches.length
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1
            }
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem
    }
    return null
}

export const shuffle = array => {
    var currentIndex = array.length,
        temporaryValue,
        randomIndex

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
    }

    return array
}

export const trackEvent = form => {
    let eventValues = {
        ...form,
        event: 'viewDemoSubmission',
        chooseYourBusiness: form.chooseYourBusiness.toUpperCase(),
        agentCount: form.agentCount,
        boost: form.interested_in_boost,
        connect: form.interested_in_connect,
        spacio: form.interested_in_spacio,
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(eventValues)

    window.fbq('trackCustom', eventValues.event, eventValues)
}

export const getStateOptions = () => {
    let allStates = USStates.concat(CAProvinces)
    return allStates
        .map(state => ({ label: state.value, value: state.value }))
        .sort((a, b) => (a.label > b.label ? 1 : -1))
        .concat([{ label: 'Other', value: NON_US_OR_CANADA_STATE }]);
}

export const getSearchParams = () => {
    return (typeof window !== 'undefined') ? window.location.search : '';
}

export const appendUtmsFromSearchToUrl = (url, search='') => {
    if ((typeof search !== 'string') || search === '') {
        return url;
    }

    const utmParams = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content'];
    const searchParamsToCopy = new URLSearchParams(search);

    let newUrl = new URL(url);
    let params = new URLSearchParams(newUrl.search);

    utmParams.forEach((param) => {
        if (searchParamsToCopy.has(param)) {
            params.set(param, searchParamsToCopy.get(param));
        }
    });

    let newSearchString = params.toString();

    if (newSearchString === '') {
        return url;
    }

    url = url.split('?')[0];
    return url + '?' + newSearchString;
}